import React, { useEffect, useState } from 'react';

interface DominanceScoreProps {
  macro: any;
}


const DominanceScore: React.FC<DominanceScoreProps> = ({ macro }) => {
  const btc = macro.btcDominance !== undefined && macro.btcDominance !== null
    ? Number(macro.btcDominance).toFixed(1)
    : '0.0';
  const eth = macro.ethDominance !== undefined && macro.ethDominance !== null
    ? Number(macro.ethDominance).toFixed(1)
    : '0.0';
  const [regime, setRegime] = useState<string>(macro.marketRegime || '--');

  // Retourne un label lisible à partir du code du régime
  const getRegimeLabel = (code: string) => {
    switch (code) {
      case 'BITCOIN_DOMINANT':
        return 'Bitcoin dominant';
      case 'ETH_ROTATION':
        return 'Rotation ETH';
      case 'ALTSEASON':
        return 'Altseason';
      case 'DEFENSIVE':
        return 'Défensif';
      case 'NEUTRAL':
        return 'Neutre';
      default:
        return code;
    }
  };
  useEffect(() => {
    fetch('/api/market-regime/current')
      .then(async res => {
        if (!res.ok) throw new Error('Erreur API');
        const data = await res.json();
        if (data && data.regime) setRegime(data.regime);
      })
      .catch(() => {
        setRegime(macro.marketRegime || '--');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div style={{
      flex: 1,
      background: '#fff',
      borderRadius: 24,
      padding: '32px 24px',
      boxShadow: '0 2px 16px #0001',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}>
      <div style={{ fontSize: 22, fontWeight: 700, color: '#1976d2' }}>Dominance BTC/ETH</div>
      <div style={{ fontSize: 32, fontWeight: 900, marginTop: 8 }}>BTC: {btc}% | ETH: {eth}%</div>
      <div style={{ fontSize: 16, marginTop: 4, color: '#888' }}>Régime détecté : {getRegimeLabel(regime)}</div>
    </div>
  );
};

export default DominanceScore;
